function initProductGalleryProgress() {
  const slider = wsMain.modules?.['pag-produto']?.cache?.['slides']?.photoSlider;
  const galleryContainer = document.querySelector('.prod-photo-container');
  const photosContainer = document.querySelector('[data-wsjs-product="photos"]');
  const thumbsContainer = document.querySelector('[data-wsjs-product="dots"]');
  const dotsContainer = photosContainer?.querySelector('.dots');

  if (!slider || !galleryContainer || !thumbsContainer || !dotsContainer) return false;
  if (dotsContainer.dataset.progressReady === 'true') return true;

  const dots = Array.from(dotsContainer.querySelectorAll('.slide-dots'));
  if (!dots.length) return false;

  dotsContainer.dataset.progressReady = 'true';
  galleryContainer.insertBefore(dotsContainer, thumbsContainer.nextSibling);
  dotsContainer.classList.add('product-gallery-progress');
  dotsContainer.querySelectorAll('.slide-indicator').forEach((item) => item.remove());

  const indicator = document.createElement('div');
  indicator.className = 'slide-indicator';
  indicator.style.width = `${100 / dots.length}%`;
  dotsContainer.appendChild(indicator);

  let isDragging = false;

  function getSizes() {
    const containerWidth = dotsContainer.offsetWidth;
    const indicatorWidth = indicator.offsetWidth || 0;
    const range = Math.max(containerWidth - indicatorWidth, 1);

    return { containerWidth, indicatorWidth, range };
  }

  function syncFromSlider() {
    if (isDragging) return;

    const details = slider.track?.details;
    if (!details) return;

    const { containerWidth, indicatorWidth, range } = getSizes();
    const progress = details.progress || 0;
    const left = Math.max(0, Math.min(progress * range, containerWidth - indicatorWidth));

    indicator.style.left = `${left}px`;
  }

  function syncFromPointer(clientX) {
    const details = slider.track?.details;
    if (!details) return;

    const { containerWidth, indicatorWidth, range } = getSizes();
    const rect = dotsContainer.getBoundingClientRect();
    const left = Math.max(0, Math.min(clientX - rect.left, containerWidth - indicatorWidth));

    indicator.style.left = `${left}px`;

    if (dots.length > 1) {
      slider.track.to((left / range) * (dots.length - 1));
    }
  }

  slider.on('detailsChanged', syncFromSlider);
  slider.on('animationEnded', syncFromSlider);
  window.addEventListener('resize', syncFromSlider);

  indicator.addEventListener('mousedown', (event) => {
    isDragging = true;
    event.preventDefault();
  });

  indicator.addEventListener('touchstart', () => {
    isDragging = true;
  });

  document.addEventListener('mousemove', (event) => {
    if (!isDragging) return;
    syncFromPointer(event.clientX);
  });

  document.addEventListener('mouseup', () => {
    if (!isDragging) return;
    isDragging = false;
    syncFromSlider();
  });

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!isDragging) return;
      syncFromPointer(event.touches[0].clientX);
      event.preventDefault();
    },
    { passive: false }
  );

  document.addEventListener('touchend', () => {
    if (!isDragging) return;
    isDragging = false;
    syncFromSlider();
  });

  syncFromSlider();

  return true;
}

function waitProductGalleryProgress() {
  let attempts = 0;

  function tryMount() {
    attempts += 1;

    if (initProductGalleryProgress() || attempts > 40) return;

    setTimeout(tryMount, 200);
  }

  tryMount();
}

try {
  isReady('pag-produto', waitProductGalleryProgress);
} catch (error) {}

function moveProductBreadcrumbIntoCard() {
  const breadcrumb = document.querySelector('.breadcrumb-container[data-wsjs-product="breadcrumb"]');
  const block = document.querySelector('.prod-block-container');

  if (!breadcrumb || !block) return false;
  if (breadcrumb.dataset.insideProductCard === 'true') return true;

  breadcrumb.dataset.insideProductCard = 'true';
  breadcrumb.classList.add('breadcrumb-inside-product-card');
  block.insertBefore(breadcrumb, block.firstChild);

  return true;
}

function waitProductBreadcrumbMove() {
  let attempts = 0;

  function tryMove() {
    attempts += 1;

    if (moveProductBreadcrumbIntoCard() || attempts > 40) return;

    setTimeout(tryMove, 200);
  }

  tryMove();
}

try {
  isReady('pag-produto', waitProductBreadcrumbMove);
} catch (error) {}

function duplicateProductCodeToPhotoSide() {
  const photoSide = document.querySelector('.prod-inside-container .prod-side-container:first-child');
  const photoContainer = document.querySelector('.prod-photo-container');
  const codeValue = document.querySelector('.prod-code-container [data-wsjs-product="code"]');
  let codeClone;
  let codeText;

  if (!photoSide || !photoContainer || !codeValue) return false;

  codeText = (codeValue.textContent || '').trim();

  if (!codeText) return false;

  codeClone = photoSide.querySelector('.product-code-floating');

  if (!codeClone) {
    codeClone = document.createElement('div');
    codeClone.className = 'product-code-floating';
    photoSide.insertBefore(codeClone, photoContainer);
  }

  codeClone.innerHTML = '<span>CÓD.: <strong></strong></span>';
  codeClone.querySelector('strong').textContent = codeText;

  return true;
}

function waitProductCodeDuplicate() {
  let attempts = 0;

  function tryDuplicate() {
    attempts += 1;

    if (duplicateProductCodeToPhotoSide() || attempts > 40) return;

    setTimeout(tryDuplicate, 200);
  }

  tryDuplicate();
}

try {
  isReady('pag-produto', waitProductCodeDuplicate);
} catch (error) {}

function moveProductMetaBelowButtons() {
  const infoBlock = document.querySelector('.prod-inside-container .prod-side-container:last-child .prod-block-container');
  const buttonsContainer = infoBlock?.querySelector('.prod-buttons-container');
  const availability = infoBlock?.querySelector('.prod-avaliable-container');
  const warranty = document.querySelector('.prod-warranty-container[data-wsjs-product="warranty"]');
  let metaContainer;

  if (!infoBlock || !buttonsContainer || !availability || !warranty) return false;

  metaContainer = infoBlock.querySelector('.product-extra-meta');

  if (!metaContainer) {
    metaContainer = document.createElement('div');
    metaContainer.className = 'product-extra-meta';
    buttonsContainer.insertAdjacentElement('afterend', metaContainer);
  }

  availability.classList.add('product-meta-item', 'product-meta-availability');
  warranty.classList.add('product-meta-item', 'product-meta-warranty');

  if (!availability.hasAttribute('data-meta-adjusted')) {
    const rawAvailabilityValue =
      availability.querySelector('[data-wsjs-product="avaliableDays"]')?.textContent?.trim() ||
      availability.textContent
        .replace(/Disponibilidade do produto:?/i, '')
        .replace(/Disponibilidade:?/i, '')
        .trim();
    const availabilityValue = rawAvailabilityValue
      .replace(/Disponibilidade do produto:?/i, '')
      .replace(/Disponibilidade:?/i, '')
      .trim();

    availability.innerHTML = `
      <h2>Disponibilidade do produto</h2>
      <span>${availabilityValue}</span>
    `;

    availability.setAttribute('data-meta-adjusted', 'true');
  }

  if (warranty.parentElement !== metaContainer) {
    metaContainer.appendChild(warranty);
  }

  if (availability.parentElement !== metaContainer) {
    metaContainer.appendChild(availability);
  }

  return true;
}

function waitProductMetaMove() {
  let attempts = 0;

  function tryMove() {
    attempts += 1;

    if (moveProductMetaBelowButtons() || attempts > 40) return;

    setTimeout(tryMove, 200);
  }

  tryMove();
}

try {
  isReady('pag-produto', waitProductMetaMove);
} catch (error) {}

let manufacturerListPromise;

function normalizeManufacturerPath(value) {
  if (!value) return '';

  try {
    return new URL(value, window.location.origin).pathname.replace(/\/+$/, '').toLowerCase();
  } catch (error) {
    return String(value).trim().replace(window.location.origin, '').replace(/\/+$/, '').toLowerCase();
  }
}

function getManufacturerLogoEntry(manufacturerLink) {
  if (!manufacturerLink || typeof ApiWS === 'undefined' || !ApiWS.Calls?.manufactures) {
    return Promise.resolve(null);
  }

  if (!manufacturerListPromise) {
    manufacturerListPromise = ApiWS.Calls.manufactures().catch(() => null);
  }

  return manufacturerListPromise.then((response) => {
    const manufacturers = response?.fabricantes;
    const href = normalizeManufacturerPath(manufacturerLink.getAttribute('href'));
    const name = (manufacturerLink.textContent || '').trim().toLowerCase();

    if (!Array.isArray(manufacturers) || (!href && !name)) return null;

    return (
      manufacturers.find((item) => normalizeManufacturerPath(item?.url) === href) ||
      manufacturers.find((item) => String(item?.nome || '').trim().toLowerCase() === name) ||
      null
    );
  });
}

function buildManufacturerCardValue(manufacturer) {
  const link = manufacturer?.querySelector('a');

  if (!link) {
    return manufacturer?.innerHTML || '';
  }

  return link.outerHTML;
}

function applyManufacturerLogo(manufacturerCard, manufacturerLink, manufacturerEntry) {
  const valueContainer = manufacturerCard?.querySelector('.product-manufacturer-card__value');

  if (!valueContainer || !manufacturerLink || !manufacturerEntry?.logotipo) return;

  const safeName = manufacturerEntry.nome || manufacturerLink.textContent || 'Fabricante';
  const safeHref = manufacturerLink.getAttribute('href') || manufacturerEntry.url || '#';

  valueContainer.innerHTML = `
    <a href="${safeHref}" class="product-manufacturer-card__logo-link" title="${safeName.trim()}">
      <img src="${manufacturerEntry.logotipo}" alt="${safeName.trim()}" class="product-manufacturer-card__logo">
    </a>
  `;
}

function moveManufacturerToOwnBlock() {
  const infoBlock = document.querySelector('.prod-inside-container .prod-side-container:last-child .prod-block-container');
  const manufacturer = infoBlock?.querySelector('.prod-code-container [data-wsjs-product="manufacturer"]');
  const manufacturerLink = manufacturer?.querySelector('a');
  const installments = document.querySelector('.prod-installments-container[data-wsjs-product="installments"]');
  const manufacturerBlock = installments?.closest('.prod-block-container');
  let manufacturerCard;

  if (!manufacturer || !manufacturerBlock) return false;

  manufacturer.classList.add('product-manufacturer-inline-hidden');

  manufacturerCard = manufacturerBlock.querySelector('.product-manufacturer-card');

  if (!manufacturerCard) {
    manufacturerCard = document.createElement('div');
    manufacturerCard.className = 'product-manufacturer-card';
    manufacturerBlock.innerHTML = '';
    manufacturerBlock.appendChild(manufacturerCard);
  }

  manufacturerCard.innerHTML = `
    <span class="product-manufacturer-card__title">Fabricado por</span>
    <span class="product-manufacturer-card__value">${buildManufacturerCardValue(manufacturer)}</span>
  `;

  if (manufacturerLink) {
    getManufacturerLogoEntry(manufacturerLink).then((manufacturerEntry) => {
      applyManufacturerLogo(manufacturerCard, manufacturerLink, manufacturerEntry);
    });
  }

  return true;
}

function waitManufacturerBlockMove() {
  let attempts = 0;

  function tryMove() {
    attempts += 1;

    if (moveManufacturerToOwnBlock() || attempts > 40) return;

    setTimeout(tryMove, 200);
  }

  tryMove();
}

try {
  isReady('pag-produto', waitManufacturerBlockMove);
} catch (error) {}

function moveProductShareBelowMeta() {
  const infoBlock = document.querySelector('.prod-inside-container .prod-side-container:last-child .prod-block-container');
  const metaContainer = infoBlock?.querySelector('.product-extra-meta');
  const originalShareContainer = infoBlock?.querySelector('.prod-social-share-container');
  const copyItem = originalShareContainer?.querySelector('[data-wsjs-product="shareCopy"]');
  const whatsappItem = originalShareContainer?.querySelector('[data-wsjs-product="shareWhatsApp"]');
  let shareWrapper;
  let shareButtons;

  if (!infoBlock || !metaContainer || !originalShareContainer || !copyItem || !whatsappItem) return false;

  originalShareContainer.classList.add('is-hidden-for-custom-share');

  shareWrapper = metaContainer.querySelector('.product-share-inline');

  if (!shareWrapper) {
    shareWrapper = document.createElement('div');
    shareWrapper.className = 'product-share-inline';
    shareWrapper.innerHTML = `
      <span class="product-share-inline__title">
        <span class="product-share-inline__icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clip-path="url(#clip0_15_207)">
              <rect width="24" height="24" fill="white"></rect>
              <path d="M19.4422 10.3492L14.8796 5.02623C14.5775 4.67378 14 4.88743 14 5.35163V8C11 8 4 11 4 20C6 15 10 14 14 14V16.6484C14 17.1126 14.5775 17.3262 14.8796 16.9738L19.4422 11.6508C19.7632 11.2763 19.7632 10.7237 19.4422 10.3492Z" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"></path>
            </g>
            <defs>
              <clipPath id="clip0_15_207">
                <rect width="24" height="24" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>
        </span>
        <span>Compartilhe</span>
      </span>
      <div class="product-share-inline__buttons"></div>
    `;

    metaContainer.appendChild(shareWrapper);
  }

  shareButtons = shareWrapper.querySelector('.product-share-inline__buttons');

  if (copyItem.parentElement !== shareButtons) {
    copyItem.classList.add('product-share-inline__button');
    shareButtons.appendChild(copyItem);
  }

  if (whatsappItem.parentElement !== shareButtons) {
    whatsappItem.classList.add('product-share-inline__button');
    shareButtons.appendChild(whatsappItem);
  }

  copyItem.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M5.49968 1H12.5997C14.8397 1 15.9597 0.999941 16.8157 1.43994C17.5681 1.81988 18.1803 2.42922 18.5637 3.17993C18.9997 4.03993 18.9997 5.1599 18.9997 7.3999V14.5M4.19967 19H12.2997C13.01 19.0804 13.7293 19.0054 14.4077 18.78C14.7827 18.5884 15.0883 18.284 15.2817 17.9099C15.5049 17.2304 15.5792 16.5109 15.4997 15.8V7.69995C15.5792 6.98912 15.5049 6.26964 15.2817 5.59009C15.0883 5.21595 14.7827 4.91161 14.4077 4.71997C13.7293 4.49461 13.01 4.41957 12.2997 4.5H4.19967C3.48937 4.41957 2.77007 4.49461 2.09167 4.71997C1.71666 4.91161 1.41104 5.21595 1.21768 5.59009C0.994479 6.26964 0.920127 6.98912 0.999677 7.69995V15.8C0.920127 16.5109 0.994479 17.2304 1.21768 17.9099C1.41104 18.284 1.71666 18.5884 2.09167 18.78C2.77007 19.0054 3.48937 19.0804 4.19967 19Z" stroke="#4F555C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `;

  whatsappItem.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="19.838" height="20" viewBox="0 0 19.838 20">
      <g transform="translate(-1)">
        <path d="M17.973 3.919A9.731 9.731 0 0 0 11 1a9.874 9.874 0 0 0-9.892 9.946 10.437 10.437 0 0 0 1.3 4.919L1 21l5.243-1.351a9.652 9.652 0 0 0 4.7 1.189 9.943 9.943 0 0 0 9.892-9.946 9.81 9.81 0 0 0-2.865-6.973ZM11 19.162a8.031 8.031 0 0 1-4.162-1.135l-.324-.162-3.135.811.811-3.081-.216-.324a8.205 8.205 0 1 1 11.3 2.649A7.88 7.88 0 0 1 11 19.162Zm4.757-6-.595-.27s-.865-.378-1.405-.649c-.054 0-.108-.054-.162-.054a.781.781 0 0 0-.378.108s-.054.054-.811.919a.3.3 0 0 1-.27.162h-.054a.41.41 0 0 1-.216-.108l-.27-.108a5.255 5.255 0 0 1-1.568-1.027c-.108-.108-.27-.216-.378-.324a6.037 6.037 0 0 1-1.027-1.3l-.054-.108c-.054-.054-.054-.108-.108-.216a.405.405 0 0 1 .054-.27s.216-.27.378-.432c.108-.108.162-.27.27-.378a.666.666 0 0 0 .108-.541 21.044 21.044 0 0 0-.865-2.054.626.626 0 0 0-.378-.27H7.432c-.108 0-.216.054-.324.054l-.054.054c-.108.054-.216.162-.324.216-.108.108-.162.216-.27.324a2.757 2.757 0 0 0-.595 1.676 3.206 3.206 0 0 0 .27 1.243l.054.162a9.005 9.005 0 0 0 2 2.757l.216.216a3.262 3.262 0 0 1 .432.432 9.659 9.659 0 0 0 3.892 2.054c.162.054.378.054.541.108h.541a2 2 0 0 0 .811-.216c.162-.108.27-.108.378-.216L15.108 15c.108-.108.216-.162.324-.27a1.433 1.433 0 0 0 .27-.324 3.1 3.1 0 0 0 .216-.757V13.27a.669.669 0 0 0-.162-.108Z" transform="translate(0 -1)" fill="#222"></path>
      </g>
    </svg>
  `;

  return true;
}

function waitProductShareMove() {
  let attempts = 0;

  function tryMove() {
    attempts += 1;

    if (moveProductShareBelowMeta() || attempts > 40) return;

    setTimeout(tryMove, 200);
  }

  tryMove();
}

try {
  isReady('pag-produto', waitProductShareMove);
} catch (error) {}

function adjustShippingCardLayout() {
  const shippingContainer = document.querySelector('.prod-shipping-container[data-wsjs-product="shippig-container"]');
  const shippingHead = shippingContainer?.querySelector('.prod-shipping-head');
  const shippingForm = shippingContainer?.querySelector('.prod-shipping-form');
  const helpLink = shippingContainer?.querySelector('a.tag-link');
  const shippingInput = shippingForm?.querySelector('input[type="text"]');
  const shippingButton = shippingForm?.querySelector('button[data-wsjs-shipping]');

  if (!shippingContainer || !shippingHead || !shippingForm || !helpLink || !shippingInput || !shippingButton) {
    return false;
  }

  shippingContainer.classList.add('product-shipping-customized');
  shippingContainer.closest('.prod-block-container')?.classList.add('product-shipping-block');
  shippingHead.appendChild(helpLink);
  shippingInput.setAttribute('placeholder', 'Digite seu CEP');
  shippingButton.textContent = 'OK';

  return true;
}

function waitShippingCardLayout() {
  let attempts = 0;

  function tryAdjust() {
    attempts += 1;

    if (adjustShippingCardLayout() || attempts > 40) return;

    setTimeout(tryAdjust, 200);
  }

  tryAdjust();
}

try {
  isReady('pag-produto', waitShippingCardLayout);
} catch (error) {}

function getLastVisitedBlock() {
  const viewport =
    document.querySelector('.product-last-visited-block [data-wsjs-prod-list="previous"]') ||
    document.querySelector('[data-wsjs-prod-list="previous"]');
  let block;

  if (!viewport) {
    return null;
  }

  block =
    viewport.closest('.product-last-visited-block') ||
    viewport.closest('section') ||
    viewport.parentElement;

  if (!block) {
    return null;
  }

  block.classList.add('product-last-visited-block');

  return block;
}

function mountLastVisitedArrows() {
  const block = getLastVisitedBlock();
  const viewport = block?.querySelector('[data-wsjs-prod-list="previous"]');
  const listHolder = viewport?.querySelector('.prod-list-holder');
  let nav;
  let buttonUp;
  let buttonDown;

  if (!block || !viewport || !listHolder || !listHolder.children.length) {
    return false;
  }

  viewport.classList.add('product-last-visited-viewport');

  if (viewport.dataset.lastVisitedBound === 'true') {
    if (typeof window.syncLastVisitedViewport === 'function') {
      window.syncLastVisitedViewport();
    }

    return true;
  }

  nav = block.querySelector('.product-last-visited-nav');

  if (!nav) {
    nav = document.createElement('div');
    nav.className = 'product-last-visited-nav';
    nav.innerHTML = `
      <button type="button" class="product-last-visited-nav__button product-last-visited-nav__button--up" aria-label="Subir últimos visitados"></button>
      <button type="button" class="product-last-visited-nav__button product-last-visited-nav__button--down" aria-label="Descer últimos visitados"></button>
    `;
    block.appendChild(nav);
  }

  if (nav.dataset.bound === 'true') {
    if (typeof window.syncLastVisitedArrowsState === 'function') {
      window.syncLastVisitedArrowsState();
    }

    return true;
  }

  buttonUp = nav.querySelector('.product-last-visited-nav__button--up');
  buttonDown = nav.querySelector('.product-last-visited-nav__button--down');

  function getStep() {
    const firstCard = listHolder.querySelector('.prod-showcase-holder');
    const gap = parseFloat(window.getComputedStyle(listHolder).gap || '0') || 0;

    return firstCard ? Math.ceil(firstCard.getBoundingClientRect().height + gap) : 260;
  }

  function syncViewportHeight() {
    const cards = Array.from(listHolder.querySelectorAll('.prod-showcase-holder'));
    const gap = parseFloat(window.getComputedStyle(listHolder).gap || '0') || 0;
    const visibleCards = cards.slice(0, 3);
    const height =
      visibleCards.reduce((total, card) => total + Math.ceil(card.getBoundingClientRect().height), 0) +
      Math.max(visibleCards.length - 1, 0) * gap;

    if (height > 0) {
      viewport.style.maxHeight = `${height}px`;
      viewport.style.height = `${height}px`;
    }
  }

  function updateNavState() {
    syncViewportHeight();

    const maxScroll = Math.max(viewport.scrollHeight - viewport.clientHeight, 0);
    const hasOverflow = maxScroll > 8;

    nav.classList.toggle('is-hidden', !hasOverflow);
    buttonUp.disabled = !hasOverflow || viewport.scrollTop <= 8;
    buttonDown.disabled = !hasOverflow || viewport.scrollTop >= maxScroll - 8;
  }

  function bindImageResync() {
    const images = listHolder.querySelectorAll('img');

    images.forEach((image) => {
      if (image.dataset.lastVisitedHeightBound === 'true') return;

      image.dataset.lastVisitedHeightBound = 'true';

      if (!image.complete) {
        image.addEventListener('load', updateNavState, { once: true });
        image.addEventListener('error', updateNavState, { once: true });
      }
    });
  }

  function scrollViewport(direction) {
    viewport.scrollBy({
      top: getStep() * direction,
      behavior: 'smooth'
    });
  }

  nav.dataset.bound = 'true';
  viewport.dataset.lastVisitedBound = 'true';
  buttonUp.addEventListener('click', () => scrollViewport(-1));
  buttonDown.addEventListener('click', () => scrollViewport(1));
  viewport.addEventListener('scroll', updateNavState, { passive: true });
  window.addEventListener('resize', updateNavState);

  window.syncLastVisitedArrowsState = updateNavState;
  bindImageResync();
  updateNavState();
  setTimeout(updateNavState, 150);
  setTimeout(updateNavState, 500);
  setTimeout(updateNavState, 1000);

  return true;
}

function waitLastVisitedArrows() {
  let attempts = 0;

  function tryMount() {
    attempts += 1;

    if (mountLastVisitedArrows() || attempts > 60) return;

    setTimeout(tryMount, 250);
  }

  tryMount();
}

function observeLastVisitedArrows() {
  const block = getLastVisitedBlock();
  let observer;

  if (!block || block.dataset.lastVisitedObserved === 'true') return false;

  block.dataset.lastVisitedObserved = 'true';
  observer = new MutationObserver(() => {
    mountLastVisitedArrows();
  });

  observer.observe(block, {
    childList: true,
    subtree: true
  });

  return true;
}

try {
  isReady('pag-produto', waitLastVisitedArrows);
} catch (error) {}

try {
  isReady('pag-produto', observeLastVisitedArrows);
} catch (error) {}

function applyProductAccordionEffect(accordionRoot) {
  if (!accordionRoot) return;

  const items = Array.from(
    accordionRoot.querySelectorAll('.product-description-accordion__item')
  );

  function getAnswer(item) {
    return item?.querySelector('.product-description-accordion__answer');
  }

  function stopAnimation(answer) {
    if (!answer) return;

    answer.style.height = answer.getBoundingClientRect().height + 'px';
    answer.style.transition = 'none';
    answer.getBoundingClientRect();
    answer.style.transition = '';
  }

  function closeItem(item) {
    const answer = getAnswer(item);

    if (!item || !item.open || !answer) {
      item?.removeAttribute('open');
      return;
    }

    answer.style.height = answer.getBoundingClientRect().height + 'px';
    answer.style.opacity = '1';

    requestAnimationFrame(function () {
      answer.style.height = '0px';
      answer.style.opacity = '0';
    });

    answer.addEventListener('transitionend', function handleClose(event) {
      if (event.propertyName !== 'height') {
        return;
      }

      answer.removeEventListener('transitionend', handleClose);
      item.removeAttribute('open');
      answer.style.height = '';
    });
  }

  function openItem(item) {
    const answer = getAnswer(item);

    if (!item || !answer) {
      item?.setAttribute('open', '');
      return;
    }

    item.setAttribute('open', '');
    answer.style.height = '0px';
    answer.style.opacity = '0';

    requestAnimationFrame(function () {
      answer.style.height = answer.scrollHeight + 'px';
      answer.style.opacity = '1';
    });

    answer.addEventListener('transitionend', function handleOpen(event) {
      if (event.propertyName !== 'height') {
        return;
      }

      answer.removeEventListener('transitionend', handleOpen);
      answer.style.height = 'auto';
    });
  }

  items.forEach(function (item) {
    const answer = getAnswer(item);
    const summary = item.querySelector('.product-description-accordion__summary');

    if (!answer || !summary) {
      return;
    }

    if (item.dataset.effectBound === 'true') {
      return;
    }

    if (item.hasAttribute('open')) {
      answer.style.height = 'auto';
      answer.style.opacity = '1';
    } else {
      answer.style.height = '0px';
      answer.style.opacity = '0';
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();

      stopAnimation(answer);

      if (item.open) {
        closeItem(item);
        return;
      }

      openItem(item);
    });

    item.dataset.effectBound = 'true';
  });
}

function mountProductDescriptionAccordion() {
  const block = document.querySelector('#prod-description-block');
  const featuresContainer = block?.querySelector('.prod-features-container');
  const allowedTitles = new Map([
    ['descricao', 'Descrição'],
    ['descricao do produto', 'Descrição'],
    ['composicao', 'Composição'],
    ['modo de usar', 'Modo de usar']
  ]);
  let contentHost;
  let sections;
  let firstSectionAnchor;
  let wrapper;

  function normalizeTitle(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .replace(/\s*:\s*$/, '')
      .trim()
      .toLowerCase();
  }

  function isHeadingNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.closest('.prod-features-container, .product-description-accordion')) return false;

    return allowedTitles.has(normalizeTitle(node.textContent));
  }

  function getSectionNodes(host) {
    const hostChildren = Array.from(host.children).filter(
      (child) => !child.classList?.contains('product-description-accordion')
    );
    const foundSections = [];
    let currentSection = null;

    hostChildren.forEach((child) => {
      if (child === featuresContainer) {
        return;
      }

      if (isHeadingNode(child)) {
        currentSection = {
          title: allowedTitles.get(normalizeTitle(child.textContent)) || child.textContent.trim(),
          titleNode: child,
          contentNodes: []
        };

        foundSections.push(currentSection);
        return;
      }

      if (currentSection) {
        currentSection.contentNodes.push(child);
      }
    });

    return foundSections.filter((section) => section.contentNodes.length);
  }

  if (!block) return false;
  if (block.dataset.descriptionAccordionReady === 'true') return true;

  contentHost =
    Array.from(block.children).find((child) => child !== featuresContainer && child.querySelector?.('*')) ||
    block;

  sections = getSectionNodes(contentHost);

  if (sections.length < 2) return false;

  firstSectionAnchor = sections[0].titleNode;

  wrapper = document.createElement('div');
  wrapper.className = 'product-description-accordion';

  sections.forEach((section, index) => {
    const item = document.createElement('details');
    const summary = document.createElement('summary');
    const answer = document.createElement('div');

    item.className = 'product-description-accordion__item';
    if (index === 0) {
      item.open = true;
    }

    summary.className = 'product-description-accordion__summary';
    summary.textContent = section.title;

    answer.className = 'product-description-accordion__answer';

    section.contentNodes.forEach((node) => {
      answer.appendChild(node);
    });

    item.appendChild(summary);
    item.appendChild(answer);
    wrapper.appendChild(item);
    section.titleNode.remove();
  });

  if (!wrapper.children.length) return false;

  contentHost.insertBefore(wrapper, firstSectionAnchor);
  applyProductAccordionEffect(wrapper);

  block.dataset.descriptionAccordionReady = 'true';
  block.classList.add('product-description-block--accordion-ready');

  return true;
}

function waitProductDescriptionAccordion() {
  let attempts = 0;

  function tryMount() {
    attempts += 1;

    if (mountProductDescriptionAccordion() || attempts > 60) return;

    setTimeout(tryMount, 250);
  }

  tryMount();
}

try {
  isReady('pag-produto', waitProductDescriptionAccordion);
} catch (error) {}

function mountProductDescriptionAccordionFallback() {
  const block = document.querySelector('#prod-description-block');
  const contentHost = block?.querySelector('.prod-description-container');
  const allowedTitles = new Map([
    ['descricao', 'Descrição'],
    ['descricao do produto', 'Descrição'],
    ['composicao', 'Composição'],
    ['modo de usar', 'Modo de usar']
  ]);
  const sections = [];
  let currentSection = null;
  let wrapper;
  let firstSectionAnchor;

  function normalizeTitle(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .replace(/\s*:\s*$/, '')
      .trim()
      .toLowerCase();
  }

  if (!block || !contentHost) return false;
  if (contentHost.querySelector('.product-description-accordion')) return true;

  Array.from(contentHost.children).forEach((child) => {
    const normalizedTitle = normalizeTitle(child.textContent);

    if (allowedTitles.has(normalizedTitle)) {
      currentSection = {
        title: allowedTitles.get(normalizedTitle),
        titleNode: child,
        contentNodes: []
      };

      sections.push(currentSection);
      return;
    }

    if (currentSection) {
      currentSection.contentNodes.push(child);
    }
  });

  if (sections.length < 2) return false;

  firstSectionAnchor = sections[0].titleNode;
  wrapper = document.createElement('div');
  wrapper.className = 'product-description-accordion';

  sections.forEach((section, index) => {
    const item = document.createElement('details');
    const summary = document.createElement('summary');
    const answer = document.createElement('div');

    item.className = 'product-description-accordion__item';
    item.open = index === 0;

    summary.className = 'product-description-accordion__summary';
    summary.textContent = section.title;

    answer.className = 'product-description-accordion__answer';

    section.contentNodes.forEach((node) => {
      answer.appendChild(node);
    });

    item.appendChild(summary);
    item.appendChild(answer);
    wrapper.appendChild(item);
    section.titleNode.remove();
  });

  contentHost.insertBefore(wrapper, firstSectionAnchor);
  applyProductAccordionEffect(wrapper);

  block.classList.add('product-description-block--accordion-ready');

  return true;
}

function waitProductDescriptionAccordionFallback() {
  let attempts = 0;

  function tryMount() {
    attempts += 1;

    if (mountProductDescriptionAccordionFallback() || attempts > 80) return;

    setTimeout(tryMount, 250);
  }

  tryMount();
}

try {
  isReady('pag-produto', waitProductDescriptionAccordionFallback);
} catch (error) {}

console.log("[CUSTOM PAG PROD] custom-pag-prod.js carregou");

/* Remove "à vista" do preço Pix na página de produto */
(function () {
  function atualizarBadgeDescontoPixProduto() {
    var priceCash = document.querySelector('.prod-price-container [data-wsjs-product="priceCash"]');
    var productBlock;
    var discountSources;
    var discountSource;
    var discountText;
    var match;

    if (!priceCash) {
      return;
    }

    priceCash.removeAttribute("data-pix-discount-label");

    productBlock =
      priceCash.closest(".prod-block-container") ||
      document.querySelector(".prod-block-container");

    discountSources = Array.from(
      (productBlock || document).querySelectorAll(
        '.prod-infos-social-promo-container [data-wsjs-product="tagDesconto"], [data-wsjs-product="tagDesconto"], .prod-tags-desconto'
      )
    );

    discountSource = discountSources.find(function (node) {
      var text = (node.textContent || "").trim();

      return !!text && /^-\s*\d+\s*%$/.test(text.replace(/\s+/g, " "));
    });

    if (!discountSource) {
      return;
    }

    discountText = (discountSource.textContent || "").replace(/\s+/g, " ").trim();
    match = discountText.match(/-\s*\d+\s*%/);

    if (!match) {
      return;
    }

    priceCash.setAttribute(
      "data-pix-discount-label",
      match[0].replace(/\s+/g, "")
    );
  }

  function normalizarTextoPixProduto() {
    var node = document.querySelector('.prod-price-container [data-wsjs-product="priceCash"]');
    var text;
    var cleaned;

    if (!node) {
      return;
    }

    text = (node.textContent || "").trim();

    if (!text) {
      return;
    }

    cleaned = text
      .replace(/\s+à\s+vista/gi, "")
      .replace(/\s+a\s+vista/gi, "")
      .trim();

    if (cleaned && cleaned !== text) {
      node.textContent = cleaned;
    }

    atualizarBadgeDescontoPixProduto();
  }

  function initNormalizarTextoPixProduto() {
    var observer;

    normalizarTextoPixProduto();

    observer = new MutationObserver(normalizarTextoPixProduto);
    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initNormalizarTextoPixProduto);
  } else {
    initNormalizarTextoPixProduto();
  }
})();

(function () {
  function isProductPageForAccordion() {
    var etapaInput = document.getElementById("HdEtapaLoja");

    return !!(
      (etapaInput && etapaInput.value === "PRODUTO") ||
      document.querySelector('h1[data-wsjs-product="name"]') ||
      document.querySelector('[data-wsjs-product="container"]') ||
      document.getElementById("prod-description-block")
    );
  }

  function initProductDescriptionAccordion() {
    console.log("[DEBUG DESCRIÇÃO] tentando montar accordion...");

    var block = document.getElementById("prod-description-block");
    var contentHost = block && block.querySelector(".prod-description-container");
    var clientsReview = block && block.querySelector("#clients-review");

    console.log("[DEBUG DESCRIÇÃO] block:", block);
    console.log("[DEBUG DESCRIÇÃO] contentHost:", contentHost);

    if (!isProductPageForAccordion() || !block || !contentHost) {
      console.warn("[DEBUG DESCRIÇÃO] abortou: página/bloco/container não encontrado.");
      return false;
    }

    if (contentHost.querySelector(".product-description-accordion")) {
      console.log("[DEBUG DESCRIÇÃO] accordion já existe.");
      return true;
    }

    var directSections = Array.from(contentHost.children).filter(function (child) {
      var titleNode = child.querySelector(":scope > h2, :scope > h3");
      var contentNode = child.querySelector(":scope > div");

      return !!titleNode && !!contentNode;
    });

    console.log("[DEBUG DESCRIÇÃO] directSections:", directSections.length, directSections);

    if (directSections.length < 1) {
      console.warn("[DEBUG DESCRIÇÃO] nenhuma seção válida encontrada para accordion.");
      return false;
    }

    var wrapper = document.createElement("div");
    wrapper.className = "product-description-accordion";

    directSections.forEach(function (sectionNode, index) {
      var item = document.createElement("details");
      var summary = document.createElement("summary");
      var answer = document.createElement("div");
      var titleNode = sectionNode.querySelector(":scope > h2, :scope > h3");
      var contentNode = sectionNode.querySelector(":scope > div");

      item.className = "product-description-accordion__item";
      item.open = index === 0;

      summary.className = "product-description-accordion__summary";
      summary.textContent = (titleNode.textContent || "").trim();

      answer.className = "product-description-accordion__answer";
      answer.appendChild(contentNode);

      item.appendChild(summary);
      item.appendChild(answer);
      wrapper.appendChild(item);

      sectionNode.remove();
    });

    applyProductAccordionEffect(wrapper);

    if (clientsReview) {
      var reviewTitleNode = clientsReview.querySelector(":scope > h2, :scope > h3");
      var reviewContentNodes = Array.from(clientsReview.children).filter(function (child) {
        return child !== reviewTitleNode;
      });

      if (reviewTitleNode && reviewContentNodes.length) {
        var reviewItem = document.createElement("details");
        var reviewSummary = document.createElement("summary");
        var reviewAnswer = document.createElement("div");

        reviewItem.className = "product-description-accordion__item";
        reviewSummary.className = "product-description-accordion__summary";
        reviewSummary.textContent = (reviewTitleNode.textContent || "").trim();
        reviewAnswer.className = "product-description-accordion__answer";

        reviewContentNodes.forEach(function (node) {
          reviewAnswer.appendChild(node);
        });

        reviewItem.appendChild(reviewSummary);
        reviewItem.appendChild(reviewAnswer);
        wrapper.appendChild(reviewItem);

        applyProductAccordionEffect(wrapper);

        clientsReview.remove();
      }
    }

    contentHost.appendChild(wrapper);
    block.classList.add("product-description-block--accordion-ready");

    console.log("[DEBUG DESCRIÇÃO] accordion criado com sucesso.");
    return true;
  }

  function iniciarAccordionProduto() {
    var debounceTimer;

    function tentar() {
      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(function () {
        initProductDescriptionAccordion();
      }, 120);
    }

    initProductDescriptionAccordion();

    var observer = new MutationObserver(function () {
      tentar();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener("load", function () {
      initProductDescriptionAccordion();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciarAccordionProduto);
  } else {
    iniciarAccordionProduto();
  }
})();

(function () {
  function isProductPage() {
    var etapaInput = document.getElementById("HdEtapaLoja");
    var temEtapaProduto = !!(etapaInput && etapaInput.value === "PRODUTO");
    var temTituloProduto = !!document.querySelector('h1[data-wsjs-product="name"]');
    var temContainerProduto = !!document.querySelector('[data-wsjs-product="container"]');
    var temDescricaoProduto = !!document.getElementById("prod-description-block");

    var resultado =
      temEtapaProduto ||
      temTituloProduto ||
      temContainerProduto ||
      temDescricaoProduto;

    if (resultado) {
      document.body.classList.add("pagina-produto-detalhe");
    }

    /*console.log("[PAG-PROD] isProductPage:", {
      etapa: etapaInput ? etapaInput.value : null,
      titulo: temTituloProduto,
      container: temContainerProduto,
      descricao: temDescricaoProduto,
      resultado: resultado
    });*/

    return resultado;
  }

  function getProductRoot() {
    var el =
      document.querySelector('.row[data-wsjs-product="container"]') ||
      document.querySelector('[data-wsjs-product="container"]') ||
      document.querySelector(".prod-container") ||
      document.querySelector(".prod-to-load");

    /*console.log("[PAG-PROD] getProductRoot:", el);*/
    return el;
  }

  function ajustarProductHomeSections() {
    var productRoot;
    var sections;
    var firstSection;

    if (!isProductPage()) {
      return false;
    }

    productRoot = getProductRoot();
    sections = Array.from(document.querySelectorAll(".product-home-section"));

    /*console.log("[PAG-PROD] productHomeSections encontradas:", sections.length);*/

    if (!productRoot || !sections.length) {
      return false;
    }

    sections.forEach(function (section, index) {
      var hasLastVisited =
        !!section.querySelector('[data-wsjs-sectype="prodLast"]') ||
        !!section.querySelector(".secLastVisited") ||
        !!section.querySelector('[data-wsjs-prod-list="previous"]');

      if (section.parentNode && productRoot.parentNode && section.previousElementSibling !== productRoot) {
        productRoot.insertAdjacentElement("afterend", section);
      }

      section.style.display = index === 0 || hasLastVisited ? "" : "none";
    });

    firstSection = sections[0];

    if (!firstSection) {
      return true;
    }

    Array.from(firstSection.querySelectorAll(".prod-list.prod-list-group")).forEach(function (group, groupIndex) {
      group.style.display = groupIndex < 2 ? "" : "none";
    });

    Array.from(firstSection.querySelectorAll(".prod-list-titles")).forEach(function (titles, titleIndex) {
      var title = titles.querySelector(".prod-list-titles-title");

      if (titleIndex === 0) {
        titles.style.display = "none";
        return;
      }

      titles.style.display = titleIndex === 1 ? "" : "none";

      if (titleIndex === 1 && title && title.textContent.trim() !== "Quem viu, viu também") {
        title.textContent = "Quem viu, viu também";
      }
    });

    return true;
  }

  function moverRelacionadosParaDentroDoProduto() {
    if (!isProductPage()) {
      console.warn("[PAG-PROD] moverRelacionados: não é página de produto.");
      return false;
    }

    var relateds = Array.from(document.querySelectorAll(".prod-related-container"));

    /*console.log("[PAG-PROD] relacionados encontrados:", relateds.length, relateds);*/

    if (!relateds.length) {
      return false;
    }

    var descricao = document.getElementById("prod-description-block");

    var blocoDescricaoCompleto =
      descricao &&
      (
        descricao.closest(".row") ||
        descricao.closest(".container") ||
        descricao.parentElement
      );

    var productRoot =
      document.querySelector('[data-wsjs-product="container"]') ||
      document.querySelector(".prod-container") ||
      document.querySelector(".prod-block-container");

    var destino = blocoDescricaoCompleto || productRoot;

    /*console.log("[PAG-PROD] destino final relacionados:", destino);*/

    if (!destino) {
      console.warn("[PAG-PROD] destino dos relacionados não encontrado.");
      return false;
    }

    relateds.forEach(function (related, index) {
      if (related.previousElementSibling === destino) {
        /*console.log("[PAG-PROD] relacionado já está no lugar correto:", index);*/
        return;
      }

      destino.insertAdjacentElement("afterend", related);
      related.classList.add("prod-related-movido-final");

      /*console.log("[PAG-PROD] relacionado movido para depois do bloco completo:", index, related);*/
    });

    return true;
  }

  function moverEstrelasProduto() {
    var estrelas = document.querySelector('[data-wsjs-product="star-container-product-description"]');
    var titulo = document.querySelector('h1[data-wsjs-product="name"]');

    /*console.log("[PAG-PROD] moverEstrelas:", {
      estrelas: !!estrelas,
      titulo: titulo ? titulo.textContent.trim().slice(0, 40) : null
    });*/

    if (!estrelas || !titulo || !titulo.parentNode) {
      return false;
    }

    if (estrelas.nextElementSibling !== titulo) {
      titulo.parentNode.insertBefore(estrelas, titulo);
    }

    estrelas.classList.add("estrelas-acima-titulo-produto");
    estrelas.style.display = "flex";
    estrelas.style.visibility = "visible";
    estrelas.style.opacity = "1";
    document.body.classList.add("pagina-produto-detalhe");

    return true;
  }

  function initLinkEstrelasParaAvaliacoes() {
    var link = document.querySelector('#link-to-reviews');

    if (!link || link.dataset.reviewLinkReady === 'true') {
      return false;
    }

    link.dataset.reviewLinkReady = 'true';

    link.addEventListener('click', function (event) {
      event.preventDefault();

      var attempts = 0;

      function tryOpenReviewAccordion() {
        attempts += 1;

        var summaries = Array.from(
          document.querySelectorAll('.product-description-accordion__summary')
        );
        var summary = summaries.find(function (node) {
          return (node.textContent || '').trim().toLowerCase().includes('avalia');
        });
        var item = summary && summary.closest('.product-description-accordion__item');
        var answer = item && item.querySelector('.product-description-accordion__answer');

        if (!summary || !item || !answer) {
          if (attempts < 20) {
            window.setTimeout(tryOpenReviewAccordion, 150);
          }
          return;
        }

        if (!item.open) {
          summary.dispatchEvent(
            new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
          );
        }

        window.setTimeout(function () {
          if (item.open) {
            answer.style.opacity = '1';
            answer.style.height = 'auto';
          }

          item.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 120);
      }

      tryOpenReviewAccordion();
    });

    return true;
  }

  function observarEstrelasProduto() {
    if (!isProductPage()) {
      return false;
    }

    var root =
      document.querySelector(".prod-block-container") ||
      document.querySelector(".customCode") ||
      document.body;

    if (!root || root.dataset.productStarsObserverReady === "true") {
      return false;
    }

    root.dataset.productStarsObserverReady = "true";

    var debounce = null;
    var observer = new MutationObserver(function () {
      window.clearTimeout(debounce);
      debounce = window.setTimeout(function () {
        moverEstrelasProduto();
        initLinkEstrelasParaAvaliacoes();
      }, 120);
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });

    window.setTimeout(moverEstrelasProduto, 300);
    window.setTimeout(moverEstrelasProduto, 800);
    window.setTimeout(function () {
      moverEstrelasProduto();
      initLinkEstrelasParaAvaliacoes();
    }, 1500);

    return true;
  }

  function garantirEstrelasProdutoAteExistirem() {
    if (!isProductPage()) {
      return false;
    }

    if (document.body.dataset.productStarsReady === "true") {
      return true;
    }

    var tentativas = 0;
    var maxTentativas = 30;
    var intervalo = null;
    var observer = null;

    function finalizar() {
      document.body.dataset.productStarsReady = "true";

      if (intervalo) {
        window.clearInterval(intervalo);
        intervalo = null;
      }

      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }

    function tentar() {
      var moveu = moverEstrelasProduto();
      var linkPronto = initLinkEstrelasParaAvaliacoes();
      var estrelas = document.querySelector('[data-wsjs-product="star-container-product-description"]');
      var titulo = document.querySelector('h1[data-wsjs-product="name"]');
      var posicionadas = !!(
        estrelas &&
        titulo &&
        estrelas.nextElementSibling === titulo &&
        estrelas.classList.contains("estrelas-acima-titulo-produto")
      );

      if (posicionadas) {
        finalizar();
        return true;
      }

      return !!(moveu || linkPronto);
    }

    if (tentar()) {
      return true;
    }

    intervalo = window.setInterval(function () {
      tentativas += 1;

      if (tentar() || tentativas >= maxTentativas) {
        if (tentativas >= maxTentativas && !document.body.dataset.productStarsReady) {
          window.clearInterval(intervalo);
          intervalo = null;
        }
      }
    }, 400);

    observer = new MutationObserver(function () {
      tentar();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener("load", tentar, { once: true });
    window.addEventListener("pageshow", tentar, { once: true });

    return true;
  }

  function moverUltimosVisitadosParaBaixoDoFrete() {
    if (!isProductPage()) {
      return false;
    }

    var ultimosVisitados =
      document.querySelector('[data-wsjs-sectype="prodLast"]') ||
      document.querySelector(".secLastVisited") ||
      document.querySelector(".prod-list-previous")?.closest("section") ||
      document.querySelector(".prod-list-previous")?.parentElement;
    var shippingContainer = document.querySelector('.prod-shipping-container[data-wsjs-product="shippig-container"]');
    var shippingBlock = shippingContainer && shippingContainer.closest(".prod-block-container");

    if (!ultimosVisitados || !shippingBlock || !shippingBlock.parentNode) {
      return false;
    }

    if (ultimosVisitados.previousElementSibling === shippingBlock) {
      return true;
    }

    shippingBlock.insertAdjacentElement("afterend", ultimosVisitados);

    return true;
  }

  var observadorRelacionados = null;

  function observarRelacionadosAteExistirem() {
    if (observadorRelacionados || !document.body) {
      return;
    }

    observadorRelacionados = new MutationObserver(function () {
      var related = document.querySelector(".prod-related-container");

      if (!related) {
        return;
      }

      if (moverRelacionadosParaDentroDoProduto()) {
        observadorRelacionados.disconnect();
        observadorRelacionados = null;
      }
    });

    observadorRelacionados.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function ajustarPaginaProduto() {
    /*console.log("[PAG-PROD] ajustarPaginaProduto rodando...");*/

    if (!isProductPage()) {
      console.warn("[PAG-PROD] página não reconhecida como produto.");
      return false;
    }

    document.body.classList.add("pagina-produto-detalhe");

    var r1 = ajustarProductHomeSections();
    var rLast = moverUltimosVisitadosParaBaixoDoFrete();
    var r2 = false;
    var relacionadosProntos = !!document.querySelector(".prod-related-container");

    if (relacionadosProntos) {
      r2 = moverRelacionadosParaDentroDoProduto();
    } else {
      observarRelacionadosAteExistirem();
    }

    var r3 = moverEstrelasProduto();
    observarEstrelasProduto();
    initLinkEstrelasParaAvaliacoes();
    garantirEstrelasProdutoAteExistirem();

    /*console.log("[PAG-PROD] resultados:", {
      productHomeSections: r1,
      ultimosVisitados: rLast,
      relacionados: r2,
      estrelas: r3,
      bodyClass: document.body.classList.contains("pagina-produto-detalhe")
    });*/

    return true;
  }

  function iniciarAjustesPaginaProduto() {
    var debounceTimer;

    /*console.log("[PAG-PROD] iniciarAjustesPaginaProduto carregou");*/

    function rodarComDebounce() {
      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(function () {
        ajustarPaginaProduto();
      }, 120);
    }

    ajustarPaginaProduto();

    var observer = new MutationObserver(function () {
      rodarComDebounce();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener("load", function () {
      ajustarPaginaProduto();
    });

    window.addEventListener("resize", function () {
      ajustarPaginaProduto();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciarAjustesPaginaProduto);
  } else {
    iniciarAjustesPaginaProduto();
  }
})();

/* ÚLTIMOS VISITADOS - LIMITA 3 PRODUTOS E TROCA SCROLL POR SETAS */
(function () {
  if (window.__pontoUltimosVisitadosInit) {
    return;
  }

  window.__pontoUltimosVisitadosInit = true;

  function initUltimosVisitadosSetas() {
    const bloco =
      document.querySelector('[data-wsjs-sectype="prodLast"]') ||
      document.querySelector(".secLastVisited") ||
      document.querySelector(".prod-list-previous")?.closest("section") ||
      document.querySelector(".prod-list-previous")?.parentElement;

    if (!bloco) return false;

    const lista = bloco.querySelector(".prod-list-previous");
    if (!lista) return false;

    const holder = lista.querySelector(".prod-list-holder") || lista.firstElementChild;
    if (!holder) return false;

    const produtos = holder.querySelectorAll(".prod-showcase-holder");
    if (!produtos.length) return false;

    bloco.classList.add("ultimos-visitados-custom");
    lista.classList.add("ultimos-visitados-scroll");

    let nav = bloco.querySelector(".ultimos-visitados-nav");

    if (!nav) {
      nav = document.createElement("div");
      nav.className = "ultimos-visitados-nav";

      nav.innerHTML = `
        <button type="button" class="ultimos-visitados-btn ultimos-visitados-btn-up" aria-label="Subir"></button>
        <button type="button" class="ultimos-visitados-btn ultimos-visitados-btn-down" aria-label="Descer"></button>
      `;

      lista.insertAdjacentElement("afterend", nav);
    }

    const btnUp = nav.querySelector(".ultimos-visitados-btn-up");
    const btnDown = nav.querySelector(".ultimos-visitados-btn-down");

    function calcularAlturaTresProdutos() {
      const cards = Array.from(holder.querySelectorAll(".prod-showcase-holder"));
      if (!cards.length) return;

      const primeiro = cards[0];
      const terceiro = cards[2] || cards[cards.length - 1];

      const altura =
        terceiro.offsetTop +
        terceiro.offsetHeight -
        primeiro.offsetTop;

      if (altura > 0) {
        lista.style.height = altura + "px";
        lista.style.maxHeight = altura + "px";
        lista.style.overflowY = "auto";
        lista.style.overflowX = "hidden";
      }
    }

    function passoScroll() {
      const cards = Array.from(holder.querySelectorAll(".prod-showcase-holder"));

      if (cards.length > 1) {
        return cards[1].offsetTop - cards[0].offsetTop;
      }

      return 180;
    }

    function atualizarSetas() {
      calcularAlturaTresProdutos();

      const maxScroll = lista.scrollHeight - lista.clientHeight;
      const temScroll = maxScroll > 8;

      nav.style.display = temScroll ? "flex" : "none";

      btnUp.disabled = !temScroll || lista.scrollTop <= 5;
      btnDown.disabled = !temScroll || lista.scrollTop >= maxScroll - 5;
    }

    if (lista.dataset.ultimosVisitadosSetas !== "true") {
      lista.dataset.ultimosVisitadosSetas = "true";

      btnUp.addEventListener("click", function () {
        lista.scrollBy({
          top: -passoScroll(),
          behavior: "smooth"
        });
      });

      btnDown.addEventListener("click", function () {
        lista.scrollBy({
          top: passoScroll(),
          behavior: "smooth"
        });
      });

      lista.addEventListener("scroll", atualizarSetas);
      window.addEventListener("resize", atualizarSetas);
    }

    holder.querySelectorAll("img").forEach(function (img) {
      if (!img.complete) {
        img.addEventListener("load", atualizarSetas, { once: true });
      }
    });

    atualizarSetas();

    setTimeout(atualizarSetas, 300);
    setTimeout(atualizarSetas, 800);
    setTimeout(atualizarSetas, 1500);

    return true;
  }

  function esperarUltimosVisitados() {
    let tentativas = 0;
    let intervalo = null;
    let observer = null;

    function limpar() {
      if (intervalo) {
        clearInterval(intervalo);
        intervalo = null;
      }

      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }

    function tentar() {
      tentativas++;

      if (initUltimosVisitadosSetas()) {
        limpar();
        return true;
      }

      if (tentativas > 160) {
        limpar();
      }

      return false;
    }

    if (document.body) {
      observer = new MutationObserver(function () {
        tentar();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    intervalo = setInterval(tentar, 250);
    tentar();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", esperarUltimosVisitados);
  } else {
    esperarUltimosVisitados();
  }

  window.addEventListener("load", function () {
    initUltimosVisitadosSetas();
  });

  window.addEventListener("pageshow", function () {
    initUltimosVisitadosSetas();
  });
})();


/* ÚLTIMOS VISITADOS - LIMITA 3 PRODUTOS E TROCA SCROLL POR SETAS */
(function () {
  if (window.__pontoUltimosVisitadosInit) {
    return;
  }

  function initUltimosVisitadosSetas() {
    const bloco =
      document.querySelector('[data-wsjs-sectype="prodLast"]') ||
      document.querySelector('.secLastVisited') ||
      document.querySelector('.prod-list-previous')?.closest('section') ||
      document.querySelector('.prod-list-previous')?.parentElement;

    if (!bloco) return false;

    const lista = bloco.querySelector('.prod-list-previous');
    if (!lista) return false;

    const holder = lista.querySelector('.prod-list-holder') || lista.firstElementChild;
    if (!holder) return false;

    const produtos = holder.querySelectorAll('.prod-showcase-holder');
    if (!produtos.length) return false;

    bloco.classList.add('ultimos-visitados-custom');
    lista.classList.add('ultimos-visitados-scroll');

    let nav = bloco.querySelector('.ultimos-visitados-nav');

    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'ultimos-visitados-nav';

      nav.innerHTML = `
        <button type="button" class="ultimos-visitados-btn ultimos-visitados-btn-up" aria-label="Subir"></button>
        <button type="button" class="ultimos-visitados-btn ultimos-visitados-btn-down" aria-label="Descer"></button>
      `;

      lista.insertAdjacentElement('afterend', nav);
    }

    const btnUp = nav.querySelector('.ultimos-visitados-btn-up');
    const btnDown = nav.querySelector('.ultimos-visitados-btn-down');

    function calcularAlturaTresProdutos() {
      const cards = Array.from(holder.querySelectorAll('.prod-showcase-holder'));
      if (!cards.length) return;

      const primeiro = cards[0];
      const terceiro = cards[2] || cards[cards.length - 1];

      const altura =
        terceiro.offsetTop +
        terceiro.offsetHeight -
        primeiro.offsetTop;

      if (altura > 0) {
        lista.style.height = altura + 'px';
        lista.style.maxHeight = altura + 'px';
        lista.style.overflowY = 'auto';
        lista.style.overflowX = 'hidden';
      }
    }

    function passoScroll() {
      const cards = Array.from(holder.querySelectorAll('.prod-showcase-holder'));

      if (cards.length > 1) {
        return cards[1].offsetTop - cards[0].offsetTop;
      }

      return 180;
    }

    function atualizarSetas() {
      calcularAlturaTresProdutos();

      const maxScroll = lista.scrollHeight - lista.clientHeight;
      const temScroll = maxScroll > 8;

      nav.style.display = temScroll ? 'flex' : 'none';

      btnUp.disabled = !temScroll || lista.scrollTop <= 5;
      btnDown.disabled = !temScroll || lista.scrollTop >= maxScroll - 5;
    }

    if (lista.dataset.ultimosVisitadosSetas !== 'true') {
      lista.dataset.ultimosVisitadosSetas = 'true';

      btnUp.addEventListener('click', function () {
        lista.scrollBy({
          top: -passoScroll(),
          behavior: 'smooth'
        });
      });

      btnDown.addEventListener('click', function () {
        lista.scrollBy({
          top: passoScroll(),
          behavior: 'smooth'
        });
      });

      lista.addEventListener('scroll', atualizarSetas);
      window.addEventListener('resize', atualizarSetas);
    }

    holder.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', atualizarSetas, { once: true });
      }
    });

    atualizarSetas();

    setTimeout(atualizarSetas, 300);
    setTimeout(atualizarSetas, 800);
    setTimeout(atualizarSetas, 1500);

    return true;
  }

  function esperarUltimosVisitados() {
    let tentativas = 0;

    const intervalo = setInterval(function () {
      tentativas++;

      if (initUltimosVisitadosSetas() || tentativas > 80) {
        clearInterval(intervalo);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', esperarUltimosVisitados);
  } else {
    esperarUltimosVisitados();
  }

  window.addEventListener('load', function () {
    initUltimosVisitadosSetas();
  });
})();



document.addEventListener("DOMContentLoaded", function () {
  function colocarAvaliacoesNoAccordion() {
    const block = document.querySelector("#prod-description-block");
    const contentHost = document.querySelector("#prod-description-block .prod-description-container") || block;
    const review = document.querySelector("#clients-review");

    if (!block || !contentHost || !review) {
      return;
    }

    let accordion = contentHost.querySelector(".product-description-accordion");

    if (!accordion) {
      accordion = document.createElement("div");
      accordion.className = "product-description-accordion";
      contentHost.appendChild(accordion);
    }

    const alreadyExists = Array.from(
      accordion.querySelectorAll(".product-description-accordion__summary")
    ).some(function (summary) {
      return summary.textContent.trim().toLowerCase().includes("avaliações");
    });

    if (alreadyExists) {
      return;
    }

    const title = review.querySelector(":scope > h2, :scope > h3");

    const item = document.createElement("details");
    const summary = document.createElement("summary");
    const answer = document.createElement("div");

    item.className = "product-description-accordion__item";
    summary.className = "product-description-accordion__summary";
    answer.className = "product-description-accordion__answer";

    summary.textContent = title ? title.textContent.trim() : "Avaliações dos clientes";

    Array.from(review.children).forEach(function (child) {
      if (child !== title) {
        answer.appendChild(child);
      }
    });

    item.appendChild(summary);
    item.appendChild(answer);
    accordion.appendChild(item);
    applyProductAccordionEffect(accordion);

    review.remove();

    block.classList.add("product-description-block--accordion-ready");

  }

  colocarAvaliacoesNoAccordion();

  setTimeout(colocarAvaliacoesNoAccordion, 500);
  setTimeout(colocarAvaliacoesNoAccordion, 1000);
  setTimeout(colocarAvaliacoesNoAccordion, 2000);
});

document.addEventListener("DOMContentLoaded", function () {
  function ajustarNotaAvaliacoes() {
    var box = document.querySelector("#client-average-data");

    if (!box) return;

    var nota = box.querySelector(".nota");
    var textoTotal = Array.from(box.querySelectorAll("p")).find(function (p) {
      return p.textContent.toLowerCase().includes("total de");
    });

    if (nota && !nota.querySelector(".nota-numero")) {
      var valorNota = nota.textContent.trim().replace(".", ",");

      nota.innerHTML = `
        <span class="nota-numero">${valorNota}</span>
        <span class="nota-total">/5</span>
      `;
    }

    if (textoTotal && !textoTotal.classList.contains("texto-media-avaliacoes")) {
      var totalMatch = textoTotal.textContent.match(/\d+/);
      var total = totalMatch ? totalMatch[0] : "";

      textoTotal.className = "texto-media-avaliacoes";
      textoTotal.innerHTML = `
        Nota média do produto com<br>
        base no total de <strong>${total} avaliações</strong>
      `;
    }
  }

  function colocarParentesesAvaliacoes() {
    var spans = document.querySelectorAll("#all-avaliations-progress-bar span[ratings]");

    spans.forEach(function (span) {
      var texto = span.textContent.trim();

      if (/^\d+$/.test(texto)) {
        span.textContent = "(" + texto + ")";
      }
    });
  }

  function acharElementoEstrelas(review) {
    var candidatosTexto = Array.from(review.querySelectorAll("*"))
      .filter(function (el) {
        var txt = el.textContent.trim();
        return /^[★☆\s]+$/.test(txt) && txt.length >= 3;
      })
      .sort(function (a, b) {
        return a.textContent.length - b.textContent.length;
      });

    if (candidatosTexto[0]) return candidatosTexto[0];

    var candidatosClasse = Array.from(
      review.querySelectorAll('[class*="star"], [id*="star"], [class*="rating"], [id*="rating"]')
    ).filter(function (el) {
      var txt = el.textContent.trim().toLowerCase();
      return !txt.includes("avaliada") && !txt.includes("avaliado") && txt.length < 80;
    });

    return candidatosClasse[0] || null;
  }

  function extrairDataAvaliacao(review) {
    var regex = /(Avaliad[ao]\s+em\s+\d{2}\/\d{2}\/\d{4})/i;
    var walker = document.createTreeWalker(review, NodeFilter.SHOW_TEXT);
    var node;

    while ((node = walker.nextNode())) {
      var texto = node.nodeValue;

      if (regex.test(texto)) {
        var match = texto.match(regex);
        var dataTexto = match[1];

        node.nodeValue = texto.replace(regex, "").replace(/\s{2,}/g, " ").trim();

        var span = document.createElement("span");
        span.className = "ws-review-date-inline";
        span.textContent = dataTexto;

        return span;
      }
    }

    return null;
  }

  function organizarAvaliacoesProduto() {
    var reviews = document.querySelectorAll("#clients-review-container > div[data-wsjs-review-id]");

    reviews.forEach(function (review) {
      if (review.dataset.layoutAjustado === "true") return;

      var estrelas = acharElementoEstrelas(review);
      var data = extrairDataAvaliacao(review);

      if (!estrelas || !data) return;

      var linha = document.createElement("div");
      linha.className = "ws-stars-date-line";

      estrelas.parentNode.insertBefore(linha, estrelas);
      linha.appendChild(estrelas);
      linha.appendChild(data);

      review.dataset.layoutAjustado = "true";
    });
  }

  function forcarNomeAvaliacaoEsquerda() {
    document.querySelectorAll("#clients-review-container > div[data-wsjs-review-id]").forEach(function (review) {
      var possibleNames = Array.from(review.querySelectorAll("b, strong, span, p, div")).filter(function (el) {
        var txt = el.textContent.trim();
        return /^[A-Za-zÀ-ÿ]+\s+[A-Za-zÀ-ÿ]\.$/.test(txt);
      });

      possibleNames.forEach(function (nameEl) {
        nameEl.style.setProperty("display", "block", "important");
        nameEl.style.setProperty("width", "100%", "important");
        nameEl.style.setProperty("text-align", "left", "important");
        nameEl.style.setProperty("margin-left", "0", "important");
        nameEl.style.setProperty("padding-left", "0", "important");
        nameEl.style.setProperty("transform", "none", "important");

        if (nameEl.parentElement) {
          nameEl.parentElement.style.setProperty("text-align", "left", "important");
          nameEl.parentElement.style.setProperty("justify-content", "flex-start", "important");
          nameEl.parentElement.style.setProperty("align-items", "flex-start", "important");
        }
      });
    });
  }

  function initAjustesAvaliacoesProduto() {
    ajustarNotaAvaliacoes();
    colocarParentesesAvaliacoes();
    organizarAvaliacoesProduto();
    forcarNomeAvaliacaoEsquerda();
  }

  initAjustesAvaliacoesProduto();

  setTimeout(initAjustesAvaliacoesProduto, 500);
  setTimeout(initAjustesAvaliacoesProduto, 1000);
  setTimeout(initAjustesAvaliacoesProduto, 2000);
});

document.addEventListener("DOMContentLoaded", function () {
  function alterarTextoMaisInformacoes() {
    const link = document.querySelector('[data-wsjs-product="linkDesc"]');

    if (!link) return;

    /* Só mostra o link se a descrição curta estiver preenchida */
    const shortDesc = document.querySelector('[data-wsjs-product="shortDesc"]');
    var textoDescCurta = shortDesc ? (shortDesc.textContent || "").trim() : "";

    if (!textoDescCurta) {
      link.style.display = "none";
      var moreContainer = link.closest(".prod-more-container");
      if (moreContainer) moreContainer.style.display = "none";
      return;
    }

    link.style.display = "";
    var moreContainer = link.closest(".prod-more-container");
    if (moreContainer) moreContainer.style.display = "";
    link.textContent = "Leia mais";
  }

  alterarTextoMaisInformacoes();

  setTimeout(alterarTextoMaisInformacoes, 500);
  setTimeout(alterarTextoMaisInformacoes, 1000);
  setTimeout(alterarTextoMaisInformacoes, 2000);
});

(function () {
  /* Padroniza o topo da sidebar "Ver parcelas" (.ws-modal-parcelas, montada
     via JS pelo módulo padrão wsapi3-pag-prod-rules) pra seguir o mesmo
     padrão visual do carrinho/login/filtros: ícone + título à esquerda, X à
     direita, borda inferior colada nos cantos. Feito aqui (tema), não no
     módulo padrão, porque é preferência visual só desta loja — o módulo
     continua gerando .ws-modal-parcelas-content > h2 "Meios de
     pagamentos..." + o X solto, exatamente como sempre; aqui só criamos a
     topbar nova e movemos o X existente pra dentro dela (mesmo onclick
     original, só reposicionado no DOM). O miolo não é tocado.

     installments() do módulo padrão pode rodar mais de uma vez (troca de
     variação recalculando preço) e cria um novo .ws-modal-parcelas a cada
     chamada — por isso roda em polling contínuo, marcando cada modal já
     tratado com data-topbar-applied, em vez de rodar uma única vez. */
  function aplicarTopbarParcelas() {
    document.querySelectorAll('.ws-modal-parcelas:not([data-topbar-applied="1"])').forEach(function (modal) {
      var wrapper = modal.querySelector('.ws-modal-parcelas__wrapper');
      var closeBtn = modal.querySelector('.ws-modal-parcelas-close');
      if (!wrapper || !closeBtn) return;

      var topbar = document.createElement('div');
      topbar.className = 'ws-modal-parcelas-topbar';
      topbar.innerHTML =
        '<h2>' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>' +
            '<line x1="1" y1="10" x2="23" y2="10"></line>' +
          '</svg>' +
          '<span>Formas de pagamento</span>' +
        '</h2>';

      topbar.appendChild(closeBtn);
      wrapper.insertBefore(topbar, wrapper.firstChild);
      modal.setAttribute('data-topbar-applied', '1');
    });
  }

  setInterval(aplicarTopbarParcelas, 500);
})();

/* Página de produto: linha extra "Nx de R$ Y com juros" (máximo de parcelas COM juros)
   abaixo do parcelamento sem juros (priceInstallment). Mesma regra do módulo padrão
   (wsapi3-pag-prod-rules: installments/priceInstallment): nº máximo limitado pelo
   valor mínimo da parcela; valor da parcela pela Tabela Price (wsMain.data.compostFeeValue).
   Só aparece quando existe linha sem juros E o máximo passa de juros_inicia com juros > 0.
   Recalcula quando a variação troca o preço (assinatura preço+parcelas). */
(function () {
  function precosProduto() {
    try {
      return (typeof wsMain !== 'undefined' && wsMain.globalData && wsMain.globalData.infoProduto &&
        wsMain.globalData.infoProduto.precos) || null;
    } catch (e) { return null; }
  }

  function formatar(v) {
    return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 });
  }

  function calcularLinhaComJuros(p) {
    var preco = Number(p.preco_promocao) || Number(p.preco) || 0;
    var max = Number(p.max_parcelas) || 0;
    var inicia = Number(p.juros_inicia) || 0;
    var juros = Number(p.juros) || 0;
    var min = Number(p.valor_min_parcelas) || 0;

    if (!preco || !max || preco <= min || juros <= 0) return null;

    var n = max;
    while (n > 1 && min > 0 && preco / n < min) n--;

    /* juros desde a 1ª parcela ou máximo ainda sem juros → nada a acrescentar */
    if (inicia < 2 || n < inicia) return null;

    var i = juros / 100;
    var parcela = (preco * i) / (1 - 1 / Math.pow(1 + i, n));
    return { n: n, parcela: parcela, total: parcela * n };
  }

  function aplicarLinhaComJuros() {
    var container = document.querySelector('.prod-price-container');
    if (!container) return;
    var holder = container.querySelector('[data-wsjs-product="priceInstallment"]');
    var linha = container.querySelector('.prod-price-installment-fee');
    var p = precosProduto();
    var dados = p && holder && /sem juros/i.test(holder.textContent) ? calcularLinhaComJuros(p) : null;

    if (!dados) {
      if (linha) linha.remove();
      return;
    }

    var assinatura = dados.n + '|' + dados.parcela.toFixed(2);
    if (linha && linha.dataset.assinatura === assinatura) return;

    if (!linha) {
      linha = document.createElement('span');
      linha.className = 'prod-price-installment-fee';
    }
    linha.dataset.assinatura = assinatura;
    linha.innerHTML = dados.n + 'x de ' + formatar(dados.parcela) + ' <span>com juros</span>';
    if (linha.previousElementSibling !== holder) holder.insertAdjacentElement('afterend', linha);
  }

  document.addEventListener('DOMContentLoaded', aplicarLinhaComJuros);
  window.addEventListener('load', aplicarLinhaComJuros);
  setInterval(aplicarLinhaComJuros, 700);
})();
